import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/img/outcess-logo.png";
import Button from "../pages/USA/USA-Components/ButtonUi";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";

const Navbar = ({ variant }) => {
  const [displayNav, setDisplayNav] = useState(false);
  const [company, setCompany] = useState(false);
  const [solutions, setSolutions] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const USlinks = {
    Services: "/us/services",
    Industries: "/us/industries",
    "About Us": "/us/about Us",
    "Contact US": "/us/contact us",
  };

  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
        setHidden(true);
      } else {
        setHidden(false);
      }

      lastScrollY.current = currentScrollY;
    };

    const handleResize = () => {
      if (window.innerWidth >= 1280) {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (variant === "us") {
    return (
      <div
        className={`w-full fixed left-0 flex flex-col py-3 px-4 sm:px-8 lg:px-16 bg-[#f5f3f4] shadow-sm z-[70] transition-all duration-300 ease-in-out ${
          hidden ? "-top-24" : "top-0"
        }`}
      >
        <div className="w-full flex justify-between items-center gap-3">
          <NavLink to={"/us"} className="flex-shrink-0">
            <img
              src={Logo}
              className="w-28 sm:w-32 lg:w-40 object-contain"
              alt="logo"
            />
          </NavLink>

          <div className="hidden xl:flex xl:w-[36%] justify-between items-center">
            {Object.keys(USlinks).map((key) => (
              <NavLink
                key={key}
                to={USlinks[key]}
                exact
                className="text-base font-medium hover:text-primary-orange"
                activeClassName="text-[#ff6600] underline decoration-primary-orange"
              >
                {key}
              </NavLink>
            ))}
          </div>

          <div className="flex items-center gap-3 xl:hidden">
            <Button variant="primary" className="hidden sm:inline-flex">
              Get started
            </Button>
            <button
              type="button"
              aria-label={isVisible ? "Close menu" : "Open menu"}
              onClick={() => setIsVisible((prev) => !prev)}
              className={`text-2xl transition-transform duration-300 ease-in-out ${
                isVisible ? "rotate-180" : "rotate-0"
              }`}
            >
              {isVisible ? <IoClose /> : <GiHamburgerMenu />}
            </button>
          </div>

          <Button variant="primary" className="hidden xl:inline-flex">
            Get started
          </Button>
        </div>

        <div
          className={`mt-3 flex flex-col gap-2 overflow-hidden transition-all duration-300 ease-in-out xl:hidden ${
            isVisible ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          {Object.keys(USlinks).map((key) => (
            <NavLink
              key={key}
              to={USlinks[key]}
              exact
              className="text-sm sm:text-base font-medium hover:text-primary-orange"
              activeClassName="text-[#ff6600] underline decoration-primary-orange"
              onClick={() => setIsVisible(false)}
            >
              {key}
            </NavLink>
          ))}
          <Button variant="primary" className="w-fit mt-1">
            Get started
          </Button>
        </div>
      </div>
    );
  }

  return (
    <nav id="navbar">
      <div id="logo">
        <NavLink to="/" exact>
          <img src={Logo} alt="Outcess" />
        </NavLink>
      </div>
      <div className="bg-screen-nav">
        <ul className="bg-nav-ul">
          <li
            onMouseEnter={() => setCompany(true)}
            onMouseLeave={() => setCompany(false)}
          >
            <p className="bg-screen-nav-title">Company</p>
            <div
              className={
                company ? "bg-screen-sub-menu display" : "bg-screen-sub-menu"
              }
            >
              <ul>
                <li>
                  <NavLink to="/about" activeClassName="active-link" exact>
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/business-partners"
                    activeClassName="active-link"
                    exact
                  >
                    Business Partners
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/ideology" activeClassName="active-link" exact>
                    Ideology
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/outcess-clients"
                    activeClassName="active-link"
                    exact
                  >
                    Clients
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/gallery" activeClassName="active-link" exact>
                    Gallery
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/faqs" activeClassName="active-link" exact>
                    FAQ
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            onMouseEnter={() => setSolutions(true)}
            onMouseLeave={() => setSolutions(false)}
          >
            <p className="bg-screen-nav-title">Solutions</p>
            <div
              className={
                solutions ? "bg-screen-sub-menu display" : "bg-screen-sub-menu"
              }
            >
              <ul>
                <li>
                  <NavLink
                    to="/business-process-outsourcing"
                    activeClassName="active-link"
                    exact
                  >
                    Business Process Outsourcing
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/customer-engagement-solutions"
                    activeClassName="active-link"
                    exact
                  >
                    AI Driven Customer Engagement Solutions
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/ai-governance-lifecycle"
                    activeClassName="active-link"
                    exact
                  >
                    AI Governance Lifecycle
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/ai-debt-recovery"
                    activeClassName="active-link"
                    exact
                  >
                    AI Debt Recovery
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/agentic-ai" activeClassName="active-link" exact>
                    Agentic AI
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <NavLink to="/case-studies" className="bg-screen-nav-title" exact>
              Case Studies
            </NavLink>
          </li>
          <li>
            <NavLink to="/careers" activeClassName="active-link" exact>
              Careers
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact-us" className="bg-screen-nav-title demo" exact>
              BOOK A DEMO
            </NavLink>
          </li>
          <li className="nav-cta-item">
            <NavLink
              to="/be-work-from-home-ready"
              activeClassName="active-link"
              exact
            >
              <button>Be remote ready</button>
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="sm-screen-nav">
        <div
          className={displayNav ? "menu-btn close" : "menu-btn"}
          onClick={() => setDisplayNav(!displayNav)}
        >
          <div className="btn-line" />
          <div className="btn-line" />
          <div className="btn-line" />
        </div>
        <div
          className={
            displayNav ? "menu-container display-menu" : "menu-container"
          }
        >
          <div className="menu-content">
            <NavLink
              to="/be-work-from-home-ready"
              activeClassName="active-link"
              exact
            >
              <button> Be remote ready</button>
            </NavLink>
            <div className="menu-grid">
              <div className="menu-grid-details">
                <p>Company</p>
                <ul>
                  <li>
                    <NavLink to="/about" activeClassName="active-link" exact>
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/business-partners"
                      activeClassName="active-link"
                      exact
                    >
                      Business Partners
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ideology" activeClassName="active-link" exact>
                      Ideology
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/isoqualitystatement"
                      activeClassName="active-link"
                      exact
                    >
                      ISO Quality Statement
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/outcess-clients"
                      activeClassName="active-link"
                      exact
                    >
                      Clients
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/careers" activeClassName="active-link" exact>
                      Careers
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/gallery" activeClassName="active-link" exact>
                      Gallery
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/faqs" activeClassName="active-link" exact>
                      FAQ
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="menu-grid-details">
                <p>Case Study</p>
                <ul>
                  <li>
                    <NavLink
                      to="/case-studies"
                      className="bg-screen-nav-title"
                      exact
                    >
                      Categories
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="menu-grid-details">
              <p>Solutions</p>
              <ul>
                <li>
                  <NavLink
                    to="/business-process-outsourcing"
                    activeClassName="active-link"
                    exact
                  >
                    Business Process Outsourcing
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/customer-engagement-solutions"
                    activeClassName="active-link"
                    exact
                  >
                    AI Driven Customer Engagement Solutions
                  </NavLink>
                </li>
                <li>
                   <NavLink
                    to="/ai-governance-lifecycle"
                    activeClassName="active-link"
                    exact
                  >
                    AI Governance Lifecycle
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/ai-debt-recovery"
                    activeClassName="active-link"
                    exact
                  >
                    AI Debt Recovery
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/agentic-ai" activeClassName="active-link" exact>
                    Agentic AI
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="menu-supports">
              <ul>
                <li>
                  <NavLink to="/contact-us" activeClassName="active-link" exact>
                    Book a Demo
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact-us" activeClassName="active-link" exact>
                    Contact Us
                  </NavLink>
                </li>
                <li>
                  <a href="https://outcessblog.lll-ll.com/">Blog</a>
                </li>
                <li>
                  <NavLink to="/faqs" activeClassName="active-link" exact>
                    FAQ
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
